export class Location {
  LocationId: number;
  LocationName: string;
  InActive: Boolean;
}
